import { Stack, Typography } from '@mui/material';
import { fDateTime } from 'src/utils/formatTime';
import { WorkflowInstanceStatus, WorkflowDashboardRunDto } from 'src/@types/workflow/types';
import { WorkflowStatusLabel } from 'src/sections/shared/workflow/instanceStatus';

const STATUS_COLUMN_WIDTH = 108;

type DashboardWorkflowRunStatusProps = {
  run: WorkflowDashboardRunDto;
};

export default function DashboardWorkflowRunStatus({ run }: DashboardWorkflowRunStatusProps) {
  return (
    <Stack spacing={0.25} sx={{ alignItems: 'flex-end', width: STATUS_COLUMN_WIDTH }}>
      <WorkflowStatusLabel
        status={run.status}
        variant={run.status === WorkflowInstanceStatus.InProgress ? 'filled' : 'outlined'}
        sx={{ height: 22 }}
      />

      <Typography variant="caption" noWrap sx={{ color: 'text.disabled' }}>
        {fDateTime(run.updatedAt)}
      </Typography>
    </Stack>
  );
}
